export default function SelectItems({ searchOptions = [], callback }: { searchOptions: any; callback?: any }) {
    const searchHandle = (e: any) => {
        const value = e.target.value;
        callback && callback(value);
    };
    return (
        <div className="ef-content temp-member-product-accessory-search">
            <select className="temp-member-product-accessory-search-select" onChange={searchHandle}>
                {searchOptions.map((item: any) => {
                    return (
                        <option value={item.value} key={item.value}>
                            {item.label}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}
